import { useRouter } from "expo-router";
import { ChevronLeftIcon } from "lucide-react-native";

import { VnButton, VnButtonPropsType } from "@/components/VnButton/VnButton";
import { cn } from "@/utils/tailwind";

type BackButtonPropsType = Pick<VnButtonPropsType, "variant"> & {
  className?: string;
  textClassName?: string;
  iconClassName?: string;
  onPress?: () => void;
};

export const BackButton = ({
  className,
  textClassName,
  iconClassName,
  variant = "outline",
  onPress,
}: BackButtonPropsType) => {
  const router = useRouter();

  const handleBackPress = () => {
    if (onPress) {
      return onPress();
    }

    router.back();
  };

  return (
    <VnButton
      className={cn(className)}
      textClassName={textClassName}
      onPress={handleBackPress}
      IconComponent={ChevronLeftIcon}
      iconProps={{
        className: iconClassName,
      }}
      i18nKey="common:back"
      variant={variant}
      textVariant="lgMedium"
    />
  );
};
